const main = () => {
    if(document.querySelector('.c-others-search-menu') === null) return;
    document.querySelector('.c-others-search-menu')
    .querySelectorAll('.c-others-search-menu__overlay,.c-buttons-close')
    .forEach(element => {
        element.addEventListener('click', (e) => {
            e.preventDefault();
            delete document.querySelector('.c-others-search-menu').dataset.isOpen;
        });
    });

    document.querySelectorAll('[data-open-search-menu]').forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.c-others-search-menu').dataset.isOpen = '';
        });
    });
}

export default main
